module.exports = __webpack_public_path__ + "static/media/galdinsPlayed_10_100.fd5a5b89.png";